import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import PpaTransp from '../../components/leis/listar/ppa';


function TranspScreen () {
    return (
        <Fragment>
            <Head titulo="Planos Plurianuais do Município de Macuco"/>
            <Header />
            <Container>
                <PpaTransp />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default TranspScreen;